module.exports = __webpack_public_path__ + "static/media/finance-feature-tile-icon-03.df768af7.svg";